import React from 'react';
import { FormattedMessage } from 'react-intl';

import classes from './styles.module.css';

function AdminFiltersToggle({ onClick }) {
    return (
        <button type="button" className={classes.FiltersToggle} onClick={onClick}>
            <FormattedMessage id="AdminFiltersToggle.label" />
        </button>
    );
}

export default AdminFiltersToggle;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AdminFiltersToggle/index.js